import React from 'react';
import { func, string } from 'prop-types';
import cx from 'classnames';

import Button from 'components/Button';
import useStyles from 'hooks/useStyles';
import { GOOGLE_MEET, ZOOM } from 'routes/live/constants/liveLessonVideoSource';

import styles from './ExternalPlayer.scss';

const ExternalPlayer = ({
  url,
  videoSource,
  chatRoomType,
  chatRoomUrl,
  t,
  title,
  description,
}) => {
  useStyles(styles);

  const sourceType = url ? videoSource : chatRoomType;
  const sourceButtonTextMapping = {
    [GOOGLE_MEET]: t(
      'live:topic.videoPlayerStatus.externalVideo.googleMeetCta',
    ),
    [ZOOM]: t('live:topic.videoPlayerStatus.externalVideo.zoomCta'),
  };

  return (
    <div className={cx(styles.root, styles.comingSoon)}>
      <h4 className={styles.title}>{title}</h4>
      <p className={styles.description}>{description}</p>
      <Button
        text={sourceButtonTextMapping[sourceType]}
        onClick={() => window.open(url || chatRoomUrl)}
      />
    </div>
  );
};

ExternalPlayer.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  t: func.isRequired,
  url: string,
  videoSource: string,
  chatRoomType: string,
  chatRoomUrl: string,
};

ExternalPlayer.defaultProps = {
  url: '',
  videoSource: '',
  chatRoomType: '',
  chatRoomUrl: '',
};

export default ExternalPlayer;
